import {getUserData} from 'Services/API';
import studentInformationService from "Services/StudentInformationService";
import {isAdminUser} from "Services/util";

/******************************************
* !!!!!!!!!!!!!!!!!!
* TODO: move the rest of these SIS calls from Reports/services/roster.js into StudentInformationService.js with the rest of the services, and refactor accordingly
* !!!!!!!!!!!!!!!!!!
*******************************************/

const fetches = {
  district: () => (getDistrict()),
  school: () => (getSchoolsForUser()), // Keyed off of auth
  classroom: (schoolId) => (getClassesForTeacher(schoolId)),
  student: (classroomId) => (getStudentsForClass(classroomId)),
}

export const fetchRoster = (type, id, cachedData = {}) => {
  if(type === 'student'){
    if(cachedData.students) return Promise.resolve(cachedData.students)
  }
  return fetches[type](id);
}

export default {
  fetchRoster,
}

// Get district
// Note: this function is adapted from getSchoolsForUser() in order to support the
// interface specified at the top of this file. We should refactor in three steps:
// 1. re-evaluate the necessity of this function, refactor this service's interface
// 2. cache results locally to avoid unecessary API calls
// 3. consolidate backend so that only one call is necessary
function getDistrict() {
  let outObject = {};
  if(getUserData().district) {
    outObject.id = getUserData().district.id;
    outObject.label = getUserData().district.label;
  } else {
    outObject.id = "";
    outObject.label = "";
    console.log("ERROR: undefined district id/label");
  }
  let outArray = [outObject];
  return Promise.resolve(outArray);
}

function getSchoolsForUser(){
  // First, see if we already have schools for this user
  if(isAdminUser(getUserData().userType) || getUserData().schools.length > 0) {
    let formattedSchools = getUserData().schools.map(school => {
      return {
        id: school.id,
        label: school.label
      }
    });
    return Promise.resolve(formattedSchools);
  }

  // If not, directly fetch schools for user
  // TODO fully deprecate this codeblock once we verify it never executes
  // This code executes when we get inconsistent results for userData
  let userId = getUserData().userId;
  return getUserNameByUserId(userId)
  .then(userName => {
    const url = "https://api.getmagicbox.com/services//user/v1.0/"+userName+"?token=11b2d93f06ac11e9a2d10a2dfa68e30a";
    return fetch(url,{method: "GET"})
    .then((resp) => resp.json())
    .then(function(resp){
      let schoolId = resp.data.schoolId;
      const schoolUrl = "https://api.getmagicbox.com/services//school/v1.0/"+schoolId+"?token=11b2d93f06ac11e9a2d10a2dfa68e30a";
      return fetch(schoolUrl,{method: "GET"})
      .then((resp) => resp.json())
      .then(function(resp){
        let outObject = {};
        outObject.id = resp.data.schoolId;
        outObject.label = resp.data.schoolName;
        let outArray = [outObject];
        return Promise.resolve(outArray);
      });
    });
  })
  .catch(err => console.log("ERROR IN MAGIC getting schools:",err));
}

async function getClassesForTeacher(schoolId){
  const {userId, skipMagic} = getUserData();
  if(skipMagic){
    return await studentInformationService.getClassesInSchool(schoolId);
  }else{
    return getUserNameByUserId(userId)
    .then(userName => {
      let url = "https://api.getmagicbox.com/services//school/v1.0/teacher/class/"+userName+"?token=11b2d93f06ac11e9a2d10a2dfa68e30a";
      if(isAdminUser(getUserData().userType)) {
        // If this is an admin, use a different, schoolId dependent, API call, using schoolId as the school's "name"
        let schoolName = schoolId;
        url = "https://api.getmagicbox.com/services//school/v1.0/school/"+schoolName+"/classes?token=11b2d93f06ac11e9a2d10a2dfa68e30a";
      }
      return fetch(url,{method: "GET"})
      .then((resp) => resp.json())
      .then(function(resp){
        let outArray = [];
        if(isAdminUser(getUserData().userType)) {
          let classData = resp.data.classList;
          for(let i = 0; i < classData.length; i++){
            outArray.push({id: classData[i].classId, label: classData[i].className});
          }
        } else {
          for(let i = 0; i < resp.data.length; i++) {
            outArray.push({id: resp.data[i].classid, label: resp.data[i].classname});
          }
        }
        return Promise.resolve(outArray);
      })
    })
    .catch(err => console.log("ERROR IN MAGIC GETTING CLASSES:",err));
  }
}

function getUserNameByUserId(userId){
  const url = "https://api.getmagicbox.com/services//user/v1.0/user/" + userId + "?token=11b2d93f06ac11e9a2d10a2dfa68e30a";
  return fetch(url,{method: "GET"})
  .then((resp) => resp.json())
  .then(function(resp){
    return Promise.resolve(resp.data.UserName);
  })
  .catch(err => console.log("ERROR IN MAGIC GETTING USERNAME:",err));
}

function preloadHmHClass(classId){
  const url = process.env.SSO_BASE_URL+"/sis/classes/" + classId + "/students";
  let correlationid = getUserData().correlationid;
  let reqHeaders = {
    'x-api-key': process.env.SSO_API_KEY,
  };
  if(correlationid) reqHeaders.correlationid = correlationid;
  return fetch(url,{
    method: "GET",
    headers: reqHeaders
  })
  .then((resp) => resp.json())
  .then((resp)=>{
    let students = Array.isArray(resp) ? resp : resp.students;
    students = resp.students.map((student)=>{
      return({
        first_name: student.givenName,
        last_name: student.familyName,
        id: student.userId,
        grade: parseInt(student.grade),
      })
    })
    return Promise.resolve(students);
  });
}

async function getStudentsForClass(classroomId){
  if(getUserData().skipMagic){
    await preloadHmHClass(classroomId);
  }
  return (await studentInformationService.getClassroomStudents(classroomId));
}